"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var navigationStyles = styles_1.makeStyles(function (theme) {
    var _a, _b, _c, _d;
    return ({
        navigationContainer: (_a = {},
            _a[theme.breakpoints.down(theme.breakpoints.values.md)] = {
                textAlign: 'center',
            },
            _a),
        backButtonContainer: (_b = {
                display: 'flex',
                padding: '0 30px',
                position: 'absolute',
                left: '0'
            },
            _b[theme.breakpoints.down(theme.breakpoints.values.lg)] = {
                margin: '5px 10px 0px',
            },
            _b[theme.breakpoints.down(theme.breakpoints.values.md)] = {
                width: '100%',
                borderBottom: "1px solid " + theme.palette.text.disabled,
                paddingBottom: 10,
                textAlign: 'center',
                position: 'unset',
                margin: '5px 10px 10px',
            },
            _b),
        innerBackButtonContainer: (_c = {
                alignItems: 'center',
                whiteSpace: 'nowrap',
                lineHeight: '14px',
                color: theme.palette.common.white,
                display: 'block',
                padding: theme.spacing(2) + " " + theme.spacing(2)
            },
            _c[theme.breakpoints.down(theme.breakpoints.values.md)] = {
                width: '100%',
            },
            _c),
        backContainer: (_d = {},
            _d[theme.breakpoints.down(theme.breakpoints.values.md)] = {
                margin: 'auto',
            },
            _d),
        backButton: {
            display: 'inline-block',
            color: theme.palette.primary.main,
            '&:hover': {
                cursor: 'pointer',
                textDecoration: 'underline',
            },
        },
        stepNumber: {
            display: 'inline-block',
            color: theme.palette.primary.main,
            fontFamily: theme.typography.fontFamily2,
            fontWeight: 100,
        },
        stepTitle: {
            display: 'inline-block',
            padding: "0 0 0 " + theme.spacing(1),
            fontWeight: 100,
        },
        stepTitleWrapper: {
            textAlign: 'center',
        },
        icon: {
            color: theme.palette.primary.main,
            fontSize: theme.typography.fontMD,
            paddingTop: '4px',
        },
        label: {
            color: theme.palette.primary.main,
            textTransform: 'uppercase',
            display: 'inline-block',
            '&:hover': {
                cursor: 'pointer',
                textDecoration: 'underline',
            },
        },
    });
}, { name: 'Checkout_Navigation' });
exports.default = navigationStyles;
